import { gql } from '@apollo/client';

const UNREAD_INBOX_COUNTS_QUERY = gql`
  query unreadInboxCounts($filter: InboxFilterInput) {
    unreadInboxCounts(filter: $filter) {
      isSuccess
      message
      count {
        unreadEventCount
        unreadInterimCount
        unreadEouCount
        allEventCount
        allInterimCount
        allEouCount
      }
    }
  }
`;

export default UNREAD_INBOX_COUNTS_QUERY;
